const AllGeneList = [
"AACS",
"AARS1",
"AASDH",
"AATF",
"ABAT",
"ABCB7",
"ABCE1",
"ABCF1",
"ABCF2",
"ABCG2",
"ACAA2",
"ACACA",
"ACADL",
"ACADVL",
"ACAT1",
"ACIN1",
"ACLY",
"ACO2",
"ACOT7",
"ACOT9",
"ACOX1",
"ACP1",
"ACSF2",
"ACSL3",
"ACSS3",
"ACTG1",
"ACTN1",
"ACTR2",
"ADH5",
"ADIRF",
"ADK",
"ADNP",
"ADSS2",
"AFDN",
"AFG3L2",
"AFP",
"AGO2",
"AHCY",
"AHCYL1",
"AHNAK",
"AHSA1",
"AK2",
"AK3",
"AK4",
"AKAP1",
"AKAP8",
"AKR1A1",
"AKR1C3",
"AKR1D1",
"AKR7A2",
"ALDH16A1",
"ALDH18A1",
"ALDH1L2",
"ALDH2",
"ALDH6A1",
"ALDH9A1",
"ALDOA",
"ALG5",
"ALMS1",
"ALS2",
"AMPD2",
"ANKFY1",
"ANKRD54",
"ANP32B",
"ANP32E",
"ANXA11",
"ANXA2",
"ANXA4",
"ANXA5",
"ANXA6",
"ANXA7",
"AP1B1",
"AP1G1",
"AP1M1",
"AP2A1",
"AP2A2",
"AP2M1",
"AP2S1",
"AP3B1",
"AP3D1",
"AP3S1",
"AP3S2",
"APBB2",
"APEX1",
"API5",
"APPL1",
"APRT",
"ARCN1",
"ARFGAP1",
"ARFGEF1",
"ARHGAP1",
"ARHGAP35",
"ARHGAP5",
"ARHGDIA",
"ARHGEF7",
"ARID1A",
"ARID1B",
"ARL6IP1",
"ARMT1",
"ARPC2",
"ARPC3",
"ARPC5",
"ARPC5L",
"ASCC3",
"ASH1L",
"ASH2L",
"ASNS",
"ASS1",
"ATAD1",
"ATAD2",
"ATAD3A",
"ATF7IP",
"ATG3",
"ATIC",
"ATM",
"ATOX1",
"ATP1B1",
"ATP2B1",
"ATP5F1A",
"ATP5F1B",
"ATP5F1C",
"ATP5F1E",
"ATP5IF1",
"ATP5PF",
"ATP5PO",
"ATP6AP2",
"ATP6V1B2",
"ATP6V1H",
"ATPAF1",
"ATXN10",
"BAD",
"BAG3",
"BAIAP2",
"BANP",
"BARGIN",
"BAZ1A",
"BAZ1B",
"BAZ2A",
"BCAP31",
"BCAS1",
"BCAS2",
"BCAT1",
"BCKDK",
"BCL9L",
"BCLAF1",
"BIN1",
"BMS1",
"BOLA2",
"BPHL",
"BPNT1",
"BPTF",
"BRD1",
"BRD3",
"BRD4",
"BRIP1",
"BROX",
"BRPF1",
"BRPF3",
"BTF3",
"BUD13",
"BUD31",
"BYSL",
"BZW1",
"BZW2",
"C4orf47",
"CAB39",
"CACNA1S",
"CACYBP",
"CAD",
"CAGE1",
"CALD1",
"CALM3",
"CALR",
"CAMK2D",
"CAMK2G",
"CAND1",
"CANX",
"CAP1",
"CAP2",
"CAPN1",
"CAPN7",
"CAPNS1",
"CAPZA1",
"CAPZA2",
"CAPZB",
"CARHSP1",
"CARS1",
"CASD1",
"CASK",
"CASP7",
"CAT",
"CAV1",
"CAVIN1",
"CBFB",
"CBR1",
"CBX1",
"CBX3",
"CBX5",
"CBY2",
"CCAR1",
"CCDC124",
"CCDC6",
"CCNT1",
"CCS",
"CCT2",
"CCT3",
"CCT4",
"CCT5",
"CCT6A",
"CCT7",
"CCT8",
"CD2BP2",
"CD59",
"CD9",
"CDC27",
"CDC34",
"CDC37",
"CDC42",
"CDK1",
"CDK11B",
"CDK12",
"CDK9",
"CDV3",
"CEBPZ",
"CENPB",
"CENPV",
"CEP170",
"CEP170B",
"CEP43",
"CERS6",
"CETN1",
"CFL1",
"CGGBP1",
"CGN",
"CHAF1A",
"CHAMP1",
"CHD1",
"CHD1L",
"CHD4",
"CHD7",
"CHERP",
"CHMP1A",
"CHMP1B",
"CHMP2B",
"CHMP3",
"CHTOP",
"CHUK",
"CIAPIN1",
"CIP2A",
"CIR1",
"CISD2",
"CKAP5",
"CKMT1A",
"CKS1B",
"CLASP1",
"CLIC1",
"CLIC4",
"CLIP1",
"CLP1",
"CLPB",
"CLPP",
"CLPTM1",
"CLPTM1L",
"CLPX",
"CLSPN",
"CLTA",
"CLTB",
"CLTC",
"CMC2",
"CNBP",
"CNN2",
"CNN3",
"CNOT1",
"CNP",
"COBLL1",
"COIL",
"COPA",
"COPB1",
"COPG1",
"COPS2",
"COPS3",
"COPZ1",
"CORO1A",
"CORO1B",
"CORO1C",
"CORO7",
"COX17",
"COX4I1",
"COX6B1",
"CPNE1",
"CPNE3",
"CPSF4",
"CPT1A",
"CPT1C",
"CRABP2",
"CRCP",
"CREBBP",
"CRIP2",
"CRTC1",
"CS",
"CSDE1",
"CSE1L",
"CSNK1A1",
"CSNK1D",
"CSNK2B",
"CSRP1",
"CSTB",
"CTBP1",
"CTBP2",
"CTNNA1",
"CTNND1",
"CTSD",
"CTSO",
"CTTN",
"CUL1",
"CUL3",
"CUL4A",
"CUL4B",
"CWC27",
"CYB5A",
"CYB5R1",
"CYB5R3",
"CYC1",
"CYFIP1",
"CYRIB",
"D2HGDH",
"DAG1",
"DAP",
"DARS1",
"DARS2",
"DBI",
"DCAF4",
"DCPS",
"DCTN1",
"DCTN2",
"DCXR",
"DDA1",
"DDB1",
"DDB2",
"DDIAS",
"DDX1",
"DDX17",
"DDX18",
"DDX21",
"DDX23",
"DDX24",
"DDX39A",
"DDX39B",
"DDX3X",
"DDX42",
"DDX46",
"DDX5",
"DDX56",
"DDX58",
"DDX6",
"DDX60L",
"DENND10",
"DGKD",
"DHCR24",
"DHX15",
"DHX30",
"DHX36",
"DHX38",
"DHX9",
"DIABLO",
"DIP2B",
"DKC1",
"DLAT",
"DLD",
"DLST",
"DMAC1",
"DNAJA1",
"DNAJA2",
"DNAJB1",
"DNAJB11",
"DNAJB2",
"DNAJC10",
"DNAJC13",
"DNAJC2",
"DNAJC7",
"DNAJC8",
"DNM1L",
"DNM2",
"DNMT1",
"DOCK6",
"DOCK7",
"DPAGT1",
"DPP3",
"DPY19L2P1",
"DPYSL3",
"DRAP1",
"DSP",
"DST",
"DSTN",
"DTD1",
"DTX3L",
"DYNC1H1",
"DYNC1LI1",
"DYNLRB1",
"EAF1",
"ECD",
"ECH1",
"ECHDC1",
"ECHS1",
"ECI2",
"ECPAS",
"EDC3",
"EDF1",
"EEA1",
"EEF1A1P5",
"EEF1A2",
"EEF1B2",
"EEF1D",
"EEF1E1",
"EEF1G",
"EEF2",
"EFTUD2",
"EHD1",
"EHD2",
"EHD4",
"EHMT1",
"EIF1",
"EIF1AX",
"EIF2A",
"EIF2B3",
"EIF2S2",
"EIF2S3",
"EIF3A",
"EIF3B",
"EIF3C",
"EIF3D",
"EIF3E",
"EIF3G",
"EIF3H",
"EIF3I",
"EIF3L",
"EIF3M",
"EIF4A1",
"EIF4B",
"EIF4E",
"EIF4G1",
"EIF4G2",
"EIF5A2",
"EIF5B",
"ELAPOR1",
"ELAVL1",
"ELMO2",
"ELMO3",
"ELOB",
"ELOC",
"EMG1",
"EML2",
"ENO1",
"EP300",
"EPB41L5",
"EPC2",
"EPHX1",
"EPPK1",
"EPRS1",
"EPS8",
"ERCC3",
"ERH",
"ERO1B",
"ERVK-5",
"ESYT1",
"ETF1",
"ETFA",
"EWSR1",
"EXOC1",
"EXOC3",
"EXOSC10",
"EXOSC7",
"EZR",
"FABP5",
"FADD",
"FAF1",
"FAH",
"FAHD2A",
"FAM120A",
"FAM136A",
"FAM13B",
"FAM3C",
"FAM50B",
"FAM76A",
"FAM76B",
"FAM83H",
"FAM98B",
"FANCD2",
"FAR1",
"FARP1",
"FARSB",
"FASN",
"FAU",
"FBL",
"FBP1",
"FBXO11",
"FBXO22",
"FCF1",
"FDPS",
"FEN1",
"FHL2",
"FIP1L1",
"FKBP1A",
"FKBP3",
"FKBP4",
"FKBP8",
"FKBP9",
"FLNA",
"FLNB",
"FLNC",
"FNDC3A",
"FOSL2",
"FOXA1",
"FOXO3",
"FSCN1",
"FTSJ3",
"FUBP1",
"FUBP3",
"FUNDC2",
"FUT8",
"FXR1",
"FXR2",
"G3BP1",
"G6PD",
"GALK2",
"GANAB",
"GAPDH",
"GAPVD1",
"GARS1",
"GART",
"GATAD2B",
"GCAT",
"GCC2",
"GCLC",
"GCLM",
"GCN1",
"GDAP1",
"GDF15",
"GDI1",
"GDI2",
"GEMIN5",
"GET3",
"GET4",
"GFM1",
"GGA1",
"GGA3",
"GGCT",
"GHITM",
"GLG1",
"GLIPR2",
"GLS",
"GLUD1",
"GMEB2",
"GMPPA",
"GNAI3",
"GNAS",
"GNB1",
"GNL2",
"GOLGB1",
"GOLT1B",
"GOT2",
"GPATCH8",
"GPD2",
"GPHN",
"GPI",
"GPS1",
"GPT2",
"GRB2",
"GRPEL1",
"GRSF1",
"GRWD1",
"GSDMC",
"GSN",
"GSPT1",
"GSR",
"GSTK1",
"GSTM3",
"GSTO1",
"GTF2F1",
"GTF2F2",
"GTF2H1",
"GTF2I",
"GTPBP1",
"GTPBP10",
"GTPBP4",
"GUK1",
"GULP1",
"H1-0",
"H1-2",
"H1-5",
"H2AC6",
"H2AX",
"H2AZ1",
"H2AZ2",
"H2BC13",
"H2BC14",
"H2BC15",
"H2BC18",
"H2BC3",
"H2BC4",
"H2BC5",
"H2BC9",
"H3-2",
"H3-3A",
"H3-4",
"H3C1",
"H3Y1",
"H4C1",
"H4C7",
"HADH",
"HADHA",
"HARS1",
"HARS2",
"HAT1",
"HBS1L",
"HDAC1",
"HDGF",
"HDLBP",
"HEATR6",
"HECTD1",
"HGS",
"HIBCH",
"HINT1",
"HK1",
"HM13",
"HMBS",
"HMCES",
"HMG20A",
"HMGA1",
"HMGA2",
"HMGB1",
"HMGB2",
"HMGB3",
"HMGCL",
"HMGCS1",
"HNRNPA1",
"HNRNPA2B1",
"HNRNPA3",
"HNRNPAB",
"HNRNPC",
"HNRNPD",
"HNRNPH3",
"HNRNPK",
"HNRNPL",
"HNRNPM",
"HNRNPR",
"HNRNPU",
"HNRNPUL1",
"HNRNPUL2",
"HOOK1",
"HOXC9",
"HP1BP3",
"HPRT1",
"HSD17B12",
"HSD17B4",
"HSDL2",
"HSP90AA1",
"HSP90AB1",
"HSP90B1",
"HSPA1B",
"HSPA4",
"HSPA4L",
"HSPA5",
"HSPA8",
"HSPA9",
"HSPB1",
"HSPD1",
"HSPE1",
"HSPH1",
"HTATIP2",
"HTT",
"HUWE1",
"HYOU1",
"HYPK",
"IARS1",
"IARS2",
"ID1",
"IDE",
"IDH1",
"IDH2",
"IDH3B",
"IGF2BP1",
"ILK",
"IMPDH1",
"IMPDH2",
"INF2",
"ING3",
"ING4",
"INPP4B",
"INSRR",
"INTS13",
"INTS3",
"INTS4",
"IPO5",
"IPO7",
"IPO9",
"IQGAP1",
"IRF2BP1",
"ISOC1",
"ISYNA1",
"ITPRID2",
"IVD",
"JADE1",
"JADE2",
"JADE3",
"JPH1",
"JPH2",
"JPT1",
"JPT2",
"JUN",
"KANSL1L",
"KARS1",
"KAT5",
"KAT6A",
"KAT6B",
"KAT7",
"KDELR2",
"KDM5B",
"KDM6A",
"KHDC4",
"KHDRBS1",
"KHSRP",
"KIF11",
"KIF1B",
"KIF2A",
"KIF2C",
"KIF5B",
"KIFC1",
"KLC1",
"KMT2A",
"KMT2B",
"KMT2C",
"KMT2D",
"KNL1",
"KPNA6",
"KPNB1",
"KRR1",
"KRT18",
"KTN1",
"LACTB",
"LACTB2",
"LAD1",
"LAP3",
"LARP1",
"LARP7",
"LARS1",
"LASP1",
"LBR",
"LCP1",
"LDB2",
"LDHA",
"LDHB",
"LGALS3",
"LILRA3",
"LIMA1",
"LMNA",
"LMNB1",
"LMTK3",
"LONP1",
"LOX",
"LPP",
"LRBA",
"LRP1",
"LRPPRC",
"LRRC59",
"LSM12",
"LSS",
"LTA4H",
"LTV1",
"LUC7L2",
"LYAR",
"LYPLA1",
"MACROH2A1",
"MAD1L1",
"MAGOH",
"MAIP1",
"MAML1",
"MAN2C1",
"MANF",
"MAOA",
"MAP1LC3B",
"MAP2K3",
"MAP3K1",
"MAP4",
"MAP7",
"MAPK1",
"MAPK3",
"MAPRE3",
"MAPT",
"MAT2A",
"MATR3",
"MAVS",
"MBD2",
"MBD3",
"MBTD1",
"MCCC1",
"MCM2",
"MCM3",
"MCM4",
"MCM5",
"MCM6",
"MCM7",
"MCRS1",
"MCTS1",
"MDC1",
"MDH1",
"MDH2",
"ME1",
"ME2",
"MEAF6",
"MECR",
"MED1",
"MED12",
"MED12L",
"MED14",
"MED6",
"MEF2D",
"METAP1",
"METTL25B",
"MGA",
"MGST1",
"MIF",
"MIOS",
"MIX23",
"MKI67",
"MKLN1",
"MLLT1",
"MMGT1",
"MORC2",
"MORF4L1",
"MOV10",
"MPV17",
"MRPL12",
"MRPL20",
"MRPL30",
"MRPL35",
"MRPL37",
"MRPL39",
"MRPL44",
"MRPL53",
"MRPS15",
"MRPS18C",
"MRPS23",
"MRPS35",
"MRPS6",
"MRPS7",
"MRPS9",
"MRTFA",
"MRTFB",
"MRTO4",
"MSH2",
"MSH6",
"MSL1",
"MSN",
"MTA2",
"MTAP",
"MT-ATP8",
"MTCH2",
"MTDH",
"MTHFD1",
"MTMR10",
"MTO1",
"MTPN",
"MTRES1",
"MTREX",
"MVP",
"MYBBP1A",
"MYDGF",
"MYEF2",
"MYH10",
"MYH7B",
"MYH9",
"MYL6",
"MYO1C",
"MYO5C",
"MYO6",
"MYOF",
"NAA10",
"NAA15",
"NAA30",
"NAA50",
"NADK2",
"NAMPT",
"NANS",
"NAP1L1",
"NAPG",
"NARS1",
"NCAPG",
"NCAPH",
"NCBP3",
"NCKAP1",
"NCL",
"NCOA2",
"NCOA3",
"NCOR1",
"NCOR2",
"NDC1",
"NDE1",
"NDUFS1",
"NDUFS6",
"NDUFV1",
"NDUFV2",
"NFIX",
"NFKB1",
"NFKB2",
"NFS1",
"NIBAN2",
"NIN",
"NIP7",
"NIPBL",
"NIPSNAP3A",
"NKTR",
"NMD3",
"NME2",
"NMI",
"NNT",
"NOB1",
"NOLC1",
"NOMO3",
"NONO",
"NOP16",
"NOP2",
"NOP58",
"NOTCH2",
"NPAT",
"NPC2",
"NPEPL1",
"NPEPPS",
"NPM1",
"NQO1",
"NRBP1",
"NSD2",
"NSD3",
"NSDHL",
"NSF",
"NSUN2",
"NT5C2",
"NUCB1",
"NUCKS1",
"NUDC",
"NUDT21",
"NUDT5",
"NUDT8",
"NUMA1",
"NUP133",
"NUP153",
"NUP188",
"NUP205",
"NUP214",
"NUP50",
"NUP85",
"NUP93",
"NUP98",
"NVL",
"NXF1",
"NXPH4",
"OAT",
"OCIAD1",
"OCIAD2",
"ODR4",
"OGDH",
"OLA1",
"OPA1",
"OR52E8",
"ORC1",
"ORC3",
"OSBP",
"OSBPL9",
"OSTF1",
"OTUD4",
"OXCT1",
"OXR1",
"P4HB",
"PABPC1",
"PABPC4",
"PABPC5",
"PACS1",
"PACS2",
"PAFAH1B1",
"PAICS",
"PAK2",
"PAK4",
"PALLD",
"PAPSS1",
"PARK7",
"PARN",
"PARP1",
"PARP8",
"PARP9",
"PATJ",
"PAWR",
"PBK",
"PCBP1",
"PCBP2",
"PCDH15",
"PCGF2",
"PCID2",
"PCK2",
"PCLAF",
"PCMT1",
"PCNP",
"PCYOX1",
"PDAP1",
"PDCD11",
"PDCD5",
"PDCD6IP",
"PDCL",
"PDHA1",
"PDHB",
"PDHX",
"PDIA3",
"PDIA4",
"PDIA6",
"PDLIM1",
"PDLIM7",
"PDS5A",
"PDS5B",
"PDXDC1",
"PEBP1",
"PES1",
"PFAS",
"PFDN5",
"PFKL",
"PFKP",
"PFN1",
"PFN2",
"PGAM1",
"PGAM5",
"PGD",
"PGK1",
"PGLS",
"PGM3",
"PHAX",
"PHB2",
"PHF10",
"PHF3",
"PHF5A",
"PHF6",
"PHGDH",
"PHIP",
"PHLDB1",
"PHYH",
"PIAS4",
"PICALM",
"PIN1",
"PIP4K2C",
"PIP5K1A",
"PIR",
"PITPNA",
"PITRM1",
"PKM",
"PLAA",
"PLCB3",
"PLEC",
"PLEKHF2",
"PLPBP",
"PLS3",
"PLSCR5",
"PMS2",
"PNPO",
"POGZ",
"POLD3",
"POLDIP3",
"POLR1D",
"POLR2A",
"POLR2B",
"POLR2J",
"POLR3A",
"POM121B",
"POP4",
"POR",
"PPA1",
"PPAT",
"PPCS",
"PPIA",
"PPIB",
"PPID",
"PPIF",
"PPIG",
"PPM1B",
"PPM1G",
"PPME1",
"PPP1CA",
"PPP1CB",
"PPP1R12A",
"PPP1R2B",
"PPP1R7",
"PPP2CA",
"PPP2R1A",
"PPP2R5C",
"PPP3CC",
"PPP4R2",
"PPP6R3",
"PRC1",
"PRCC",
"PRDX1",
"PRDX2",
"PREX1",
"PRKACA",
"PRKAR2B",
"PRKCI",
"PRKCSH",
"PRKDC",
"PRMT1",
"PRMT3",
"PRPF19",
"PRPF3",
"PRPF31",
"PRPF4",
"PRPF40A",
"PRPF40B",
"PRPF6",
"PRPF8",
"PRPSAP1",
"PRR14L",
"PRRC2A",
"PRRC2C",
"PRRX1",
"PSIP1",
"PSMA1",
"PSMA2",
"PSMA3",
"PSMA4",
"PSMA5",
"PSMA6",
"PSMB1",
"PSMB2",
"PSMB3",
"PSMB5",
"PSMC1",
"PSMC2",
"PSMC3",
"PSMC4",
"PSMC5",
"PSMC6",
"PSMD1",
"PSMD11",
"PSMD13",
"PSMD14",
"PSMD2",
"PSMD3",
"PSMD4",
"PSMD6",
"PSMD7",
"PSMD8",
"PSME2",
"PSME3",
"PSMG1",
"PSMG2",
"PSPC1",
"PTBP1",
"PTBP2",
"PTBP3",
"PTGES3",
"PTGFRN",
"PTK2",
"PTMA",
"PTPA",
"PTPN11",
"PTPN12",
"PTPN23",
"PUF60",
"PUM3",
"PURB",
"PWP2",
"PYGL",
"QARS1",
"RAB10",
"RAB11B",
"RAB11FIP1",
"RAB13",
"RAB14",
"RAB1B",
"RAB24",
"RAB31",
"RAB34",
"RAB3GAP2",
"RAB43",
"RAB5A",
"RAB5C",
"RAB7A",
"RAB8B",
"RAC1",
"RACK1",
"RAD23B",
"RAD50",
"RAD9A",
"RAE1",
"RAI1",
"RALY",
"RAN",
"RANGAP1",
"RAPH1",
"RARS1",
"RAVER1",
"RBBP4",
"RBBP7",
"RBIS",
"RBM10",
"RBM14",
"RBM17",
"RBM25",
"RBM26",
"RBM27",
"RBM28",
"RBM3",
"RBM4B",
"RBMS1",
"RBMX",
"RBPJ",
"RCC1",
"RCC2",
"RCOR1",
"RDX",
"REEP5",
"RELA",
"REPIN1",
"REPS1",
"REXO2",
"RFC2",
"RFC4",
"RFX7",
"RHOA",
"RHOC",
"RHOT1",
"RHOT2",
"RIDA",
"RING1",
"RMDN1",
"RNASEL",
"RNF40",
"ROCK1",
"ROCK2",
"RPA1",
"RPA2",
"RPGRIP1",
"RPL10",
"RPL10A",
"RPL11",
"RPL12",
"RPL13",
"RPL13A",
"RPL15",
"RPL17",
"RPL18",
"RPL18A",
"RPL19",
"RPL21",
"RPL22",
"RPL23A",
"RPL24",
"RPL26",
"RPL26L1",
"RPL27",
"RPL27A",
"RPL28",
"RPL29",
"RPL3",
"RPL30",
"RPL31",
"RPL32",
"RPL34",
"RPL35",
"RPL35A",
"RPL36",
"RPL36A",
"RPL36AL",
"RPL37",
"RPL37A",
"RPL38",
"RPL4",
"RPL5",
"RPL6",
"RPL7A",
"RPL8",
"RPL9",
"RPLP0",
"RPN1",
"RPN2",
"RPRD2",
"RPS10",
"RPS11",
"RPS13",
"RPS15",
"RPS15A",
"RPS16",
"RPS17",
"RPS18",
"RPS19",
"RPS2",
"RPS20",
"RPS23",
"RPS24",
"RPS25",
"RPS27",
"RPS27A",
"RPS27L",
"RPS28",
"RPS3",
"RPS3A",
"RPS4X",
"RPS6",
"RPS7",
"RPS8",
"RPS9",
"RRAGA",
"RRBP1",
"RRM2",
"RRP1",
"RRP15",
"RRP7A",
"RRS1",
"RSF1",
"RSL1D1",
"RSL24D1",
"RSU1",
"RTCA",
"RTCB",
"RTF2",
"RTKN",
"RTN3",
"RTRAF",
"RUFY3",
"RUVBL2",
"S100A10",
"S100A11",
"S100A16",
"S100A6",
"SACM1L",
"SAE1",
"SAFB",
"SAMD9L",
"SAMM50",
"SAP30BP",
"SARNP",
"SARS1",
"SART1",
"SART3",
"SBDS",
"SBNO1",
"SCAF1",
"SCIN",
"SCP2",
"SCRN1",
"SCYL2",
"SDAD1",
"SDCBP",
"SDHA",
"SDHB",
"SDSL",
"SEC11B",
"SEC16A",
"SEC23A",
"SEC23B",
"SEC31A",
"SEC63",
"SELENBP1",
"SELENOH",
"SEPTIN11",
"SEPTIN2",
"SEPTIN8",
"SEPTIN9",
"SERBP1",
"SERPINB6",
"SERPINH1",
"SET",
"SF1",
"SF3A1",
"SF3A2",
"SF3A3",
"SF3B1",
"SF3B3",
"SFN",
"SFPQ",
"SFXN3",
"SGO2",
"SGPL1",
"SGTA",
"SH3BGRL",
"SH3GLB1",
"SHMT1",
"SHMT2",
"SHQ1",
"SHTN1",
"SIN3A",
"SKP1",
"SLC25A1",
"SLC25A24",
"SLC25A4",
"SLC25A5",
"SLC25A6",
"SLC27A2",
"SLC27A4",
"SLC35E1",
"SLC3A2",
"SLC4A1AP",
"SLC9A3R1",
"SLK",
"SLTM",
"SMARCA4",
"SMARCA5",
"SMARCAL1",
"SMARCC1",
"SMARCC2",
"SMARCD2",
"SMC1A",
"SMC2",
"SMC3",
"SMC4",
"SMG7",
"SMTN",
"SMU1",
"SMYD5",
"SND1",
"SNF8",
"SNRNP200",
"SNRNP40",
"SNRNP70",
"SNRPA",
"SNRPA1",
"SNRPB2",
"SNRPD2",
"SNU13",
"SNW1",
"SNX1",
"SNX2",
"SNX27",
"SNX3",
"SNX6",
"SOD1",
"SON",
"SORD",
"SOX4",
"SP1",
"SP110",
"SPAG7",
"SPAG9",
"SPC25",
"SPCS2",
"SPCS3",
"SPECC1",
"SPTAN1",
"SPTBN1",
"SPTLC1",
"SPTY2D1",
"SQOR",
"SRBD1",
"SRGAP2",
"SRP54",
"SRP68",
"SRP72",
"SRPRA",
"SRPRB",
"SRRM1",
"SRRM2",
"SRRT",
"SRSF1",
"SRSF10",
"SRSF5",
"SRSF7",
"SRSF9",
"SS18",
"SS18L1",
"SSB",
"SSBP2",
"SSR2",
"SSRP1",
"ST13",
"STAM2",
"STAMBP",
"STARD10",
"STARD9",
"STAT1",
"STAT3",
"STEEP1",
"STIP1",
"STMN1",
"STT3A",
"STT3B",
"STUB1",
"SUB1",
"SUCLG1",
"SUCLG2",
"SUGP2",
"SUMO2",
"SUMO3",
"SUPT16H",
"SUPT5H",
"SURF4",
"SYAP1",
"SYNCRIP",
"SYNE2",
"SZRD1",
"TACO1",
"TADA3",
"TAF1",
"TAF15",
"TAF3",
"TAF9",
"TALDO1",
"TAOK3",
"TARBP2",
"TARDBP",
"TARS1",
"TATDN1",
"TAX1BP1",
"TBC1D24",
"TBL3",
"TCEA1",
"TCERG1",
"TCOF1",
"TCP1",
"TDG",
"TDRKH",
"TECR",
"TES",
"TEX10",
"TFAP2C",
"TFIP11",
"TFRC",
"THG1L",
"THOC1",
"THOP1",
"THRAP3",
"TIMM44",
"TIPRL",
"TJP1",
"TKT",
"TLE3",
"TLN1",
"TM9SF2",
"TMA16",
"TMED10",
"TMED9",
"TMEM209",
"TMEM256",
"TMEM43",
"TMLHE",
"TMOD3",
"TMPO",
"TMX3",
"TNFAIP8",
"TNKS1BP1",
"TNPO1",
"TOM1",
"TOM1L1",
"TOM1L2",
"TOP1",
"TOP2A",
"TOP2B",
"TP53BP1",
"TPD52L2",
"TPI1",
"TPM1",
"TPM3",
"TPM4",
"TPMT",
"TPP2",
"TPR",
"TPX2",
"TRA2B",
"TRAF2",
"TRAP1",
"TRAPPC11",
"TRAPPC5",
"TRAPPC9",
"TRIM25",
"TRIM28",
"TRIM33",
"TRIP12",
"TRIP13",
"TRIR",
"TRMT1",
"TRMT5",
"TRPS1",
"TSN",
"TSNAX",
"TSPAN31",
"TSR1",
"TSR2",
"TTC27",
"TTC37",
"TTF2",
"TTN",
"TTR",
"TUBA1B",
"TUBB",
"TUBB4B",
"TUBG2",
"TUFM",
"TVP23B",
"TWF1",
"TXNDC17",
"TXNDC5",
"TXNRD1",
"TYW5",
"U2AF1",
"U2AF2",
"U2SURP",
"UBA1",
"UBA2",
"UBA3",
"UBA6",
"UBE2H",
"UBE2K",
"UBE2L3",
"UBE2M",
"UBE2N",
"UBE2O",
"UBE2T",
"UBE2V1",
"UBE2V2",
"UBE3A",
"UBE3C",
"UBFD1",
"UBR4",
"UBTFL6",
"UCHL5",
"UFSP2",
"UGDH",
"UGGT1",
"UGGT2",
"UGP2",
"UHRF1",
"UHRF2",
"UNK",
"UPF1",
"UPF2",
"UQCRB",
"UQCRC2",
"URB1",
"USP10",
"USP14",
"USP15",
"USP22",
"USP39",
"USP5",
"USP7",
"USP8",
"USP9X",
"UTP15",
"UTP3",
"UTP4",
"UTRN",
"VAC14",
"VAMP8",
"VAPA",
"VAPB",
"VARS1",
"VAV2",
"VCL",
"VCP",
"VDAC1",
"VDAC3",
"VIM",
"VPS35L",
"WAC",
"WAPL",
"WARS1",
"WASHC4",
"WASHC5",
"WBP11",
"WDHD1",
"WDR1",
"WDR12",
"WDR33",
"WDR36",
"WDR43",
"WDR48",
"WDR5",
"WDR70",
"WDR75",
"WDR87",
"WIZ",
"WRNIP1",
"XDH",
"XPO1",
"XPO4",
"XPO7",
"XPOT",
"XRCC1",
"XRCC5",
"XRCC6",
"XRN2",
"YARS1",
"YARS2",
"YBX1",
"YEATS4",
"YLPM1",
"YTHDC1",
"YTHDC2",
"YTHDF2",
"YWHAE",
"YWHAG",
"YWHAH",
"YWHAQ",
"YWHAZ",
"ZBTB10",
"ZBTB14",
"ZBTB4",
"ZC3H11B",
"ZC3H14",
"ZC3H18",
"ZC3HAV1",
"ZCCHC9",
"ZFHX3",
"ZFP36L2",
"ZFR",
"ZMAT2",
"ZMPSTE24",
"ZMYND8",
"ZNF148",
"ZNF292",
"ZNF330",
"ZNF638",
"ZNF687",
"ZNF800",
"ZNHIT1",
"ZRSR2P1",
"ZW10",
"ZZZ3"
];

export default AllGeneList;